<div class="section-header">
  <mat-icon class="small-icon">source</mat-icon>
  <span>Fuente Data</span>
  <div class="ms-auto d-flex align-items-center gap-2">
    <mat-button-toggle-group *ngIf="tipoEditable; else tipoBadge" class="op-seg op-seg--sm" name="stkcfd"
        aria-label="Tipo de instrumento" [ngModel]="stkcfd" (ngModelChange)="stkcfdChange.emit($event)"
        hideSingleSelectionIndicator>
      <mat-button-toggle value="STK">STK</mat-button-toggle>
      <mat-button-toggle value="CFD">CFD</mat-button-toggle>
    </mat-button-toggle-group>
    <ng-template #tipoBadge><span class="tipo-badge" *ngIf="stkcfd">{{ stkcfd }}</span></ng-template>
    <mat-button-toggle-group class="fuente-toggle" name="fuenteCotizacion" aria-label="Fuente de cotización"
        [(ngModel)]="fuente" (change)="cambiarFuente()" [disabled]="fuentes.length < 2">
      <mat-button-toggle *ngFor="let f of fuentes" [value]="f">{{ etiquetas[f] }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<ng-content></ng-content>

<div class="market-quote" *ngIf="cotizacion">
  <div class="market-quote-grid">
    <span class="market-quote-symbol">{{ cotizacion.symbol }}</span>
    <span class="market-quote-side">Bid <b>{{ cotizacion.bid }}</b></span>
    <span class="market-quote-last">{{ cotizacion.last }}</span>
    <span class="market-quote-side">Ask <b>{{ cotizacion.ask }}</b></span>
  </div>
</div>
<div class="market-info" *ngIf="infoContrato">{{ infoContrato }}</div>
